"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCalcAgent = void 0;
const calcAgentMechanics_1 = require("../../calcAgentMechanics");
const convertToConcentrationLimitReceivables_1 = require("../../convertToConcentrationLimitReceivables");
const progressHelper_1 = require("../../progressHelper");
const receivableBorrowingBaseTestWaivers_1 = require("../../receivableBorrowingBaseTestWaivers");
const transform_1 = require("./transform");
const getCalcAgent = ({ borrowingBaseMechanics, loanTapeMetadata, receivableWaivers, progressCallback, f1EngineMode, }) => {
    const calcAgentMechanics = (0, calcAgentMechanics_1.createCalcAgentMechanics)({
        config: borrowingBaseMechanics,
        loanTapeMetadata,
        f1EngineMode,
    });
    const groupedReceivableWaivers = (0, receivableBorrowingBaseTestWaivers_1.groupReceivableBorrowingBaseTestWaivers)({
        receivableBorrowingBaseTestWaivers: receivableWaivers,
    });
    // Infer required structure based on formulas
    const requiredStructure = (0, transform_1.getRequiredFields)(borrowingBaseMechanics);
    // Set up storage for transformed receivables after eligibility is processed
    // Transformation function will only return a partial view of the receivable
    // Type definition will remain the same (full receivable) for compatibility with existing functions
    const concentrationLimitReceivables = [];
    const [_eligibilityProgress, // Unused for now, to be revisited
    concentrationProgress, advanceRateProgress,] = (0, progressHelper_1.createPartialProgressCallbacks)({
        progressCallback,
        weights: [45, 45, 10],
    });
    return {
        addReceivable: async (creditFacilityReceivable) => {
            const waivedEligibilityTestKeysForReceivable = groupedReceivableWaivers[creditFacilityReceivable.finleyReceivableId] ??
                new Set();
            const concentrationLimitReceivable = (0, convertToConcentrationLimitReceivables_1.transformToConcentrationLimitReceivable)({
                creditFacilityReceivable,
                calcAgentMechanics,
                waivedEligibilityTestKeysForReceivable,
            });
            // Minimize structure and add to internal array to calculate final outputs
            const minimizedStructure = (0, transform_1.transformReceivable)(concentrationLimitReceivable, requiredStructure);
            // Transformation function will only return a partial view of the receivable, but type will be coerced to full version for compatibility
            concentrationLimitReceivables.push(minimizedStructure);
            // Return for use at scope of caller to write to intermediate file
            return concentrationLimitReceivable;
        },
        getOutputs: async () => {
            const concentrationLimitCalculations = await calcAgentMechanics.evaluateConcentrationAndMutateReceivables({
                concentrationLimitReceivables,
                receivableWaivers,
                progressCallback: concentrationProgress,
            });
            const borrowingBaseReceivables = await calcAgentMechanics.evaluateAdvanceRate({
                concentrationLimitReceivables,
                progressCallback: advanceRateProgress,
            });
            const borrowingBaseReceivableMap = new Map(borrowingBaseReceivables.map((rec) => [
                rec.finleyReceivableId,
                {
                    concentrationLimitFields: rec.concentrationLimitFields,
                    concentrationLimitReasons: rec.concentrationLimitReasons,
                    concentrationLimitWaivers: rec.concentrationLimitWaivers,
                    borrowingBaseFields: rec.borrowingBaseFields,
                },
            ]));
            return {
                borrowingBaseReceivableMap,
                concentrationLimitCalculations,
            };
        },
    };
};
exports.getCalcAgent = getCalcAgent;
//# sourceMappingURL=index.js.map